module.exports = require("core-js-pure/features/object/assign");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js/object/assign.js
// module id = 3486
// module chunks = 25